const PRODUCT_PREFERENCE_OPTIONS = [
  '클래식',
  '화려함',
  '미니멀함',
  '레이어드',
  '유니크함',
  '두꺼운 밴드',
  '모던함',
  '자연 모티브',
  '남성적',
  '여성적',
];

const PREFERENCE_ALIASES = {
  클래식함: '클래식',
  화려한: '화려함',
  미니멀: '미니멀함',
  유니크한: '유니크함',
  모던한: '모던함',
  자연모티브: '자연 모티브',
};

const DEFAULT_PREFERENCE_WEIGHT = 3;

function normalizeProductPreference(value) {
  const text = String(value || '')
    .replace(/[💍👨👩]/gu, '')
    .trim();

  return PREFERENCE_ALIASES[text] || text;
}

function normalizeProductPreferences(values, { allowUnknown = false } = {}) {
  return Array.from(
    new Set(
      (Array.isArray(values) ? values : [])
        .map(normalizeProductPreference)
        .filter(
          (value) => value && (allowUnknown || PRODUCT_PREFERENCE_OPTIONS.includes(value)),
        ),
    ),
  );
}

module.exports = {
  DEFAULT_PREFERENCE_WEIGHT,
  PRODUCT_PREFERENCE_OPTIONS,
  normalizeProductPreference,
  normalizeProductPreferences,
};
